<template>
  <span
    class="tag has-text-weight-medium"
    :class="{
        'is-primary': display == 'new' || display == 'active' || display == 'fulfilled',
        'is-warning': display == 'processing',
        'is-danger': display == 'declined' || display == 'shipping-expired' || display == 'acceptance-expired',
        'is-light is-info': display == 'proposal' || display == 'draft'  || display == 'disabled'
    }"
    >{{ status }}</span
  >
</template>

<script>
export default {
  name: 'StatusTag',
  props: {
    status: String
  },
  computed: {
    display () {
      if (this.status) {
        return this.status.toLocaleLowerCase()
      }
      return ''
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/forms/StatusTag.vue